import { checkResponseFlom, flomV1 } from 'core/api';

export const editMobileUser = async ({ userId, ...otherParams }) => {
  const response = await flomV1.patch(`/api/v2/admin-page/user/${userId}`, otherParams);

  return checkResponseFlom(response);
};
